import { z } from 'zod';

import { DelinquentInterestSetting } from '../loan/DelinquentInterestSetting';
import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

const ModifyMaturityDateDIUpdates = DelinquentInterestSetting.pick({
  id: true,
  isWaived: true,
  isDeferred: true,
  endDate: true,
}).partial();

export const ModifyMaturityDateEvent = BaseLoanEvent.extend({
  type: z.literal('modifyMaturityDate'),
  maturityDate: zodDateOrString,
  newInterestRate: z.number().optional(),
  delinquentInterest: ModifyMaturityDateDIUpdates.optional(),
});

export type ModifyMaturityDateEvent = z.infer<typeof ModifyMaturityDateEvent>;
